<app-bc-modal></app-bc-modal>
<app-bc-loading></app-bc-loading>
<app-home id="app-home-sales-room"> </app-home>